import Vue from "vue";
import 'pf/vee-validate';
import Auth from './Auth';
import router from './router';
import store from './store';

window.jQuery = window.$ = require('jquery');
require("materialize-css");

new Vue({
    router,
    store,
    el: '#login',
    components: {
        Auth
    }
});
